import * as ppWeb from 'pp-web'

const SHIM_FLAG = '__nfPolnApiFetchShimInstalled'

/**
 * The CDN widget bakes a flat poln_api base (e.g. https://qa-api.getpoln.com) at build time.
 * NF on qa-b uses slot paths (https://qa-api.getpoln.com/b). Without a new widget deploy,
 * rewrite widget fetch() calls from the flat base to NF's slot-aware base.
 *
 * @returns {(() => void)|undefined} uninstall function when shim was installed
 */
export function installWidgetPolnApiFetchShim() {
  if (typeof window === 'undefined') return undefined
  if (window[SHIM_FLAG]) return undefined

  const { cfg, getServiceProfile } = ppWeb
  const svcProfile = typeof getServiceProfile === 'function' ? getServiceProfile() : null
  const slotBaseUrl = (cfg?.nf?.poln_api_base_url || cfg?.poln?.poln_api_base_url || '')
    .replace(/\/$/, '')

  if (!svcProfile || !slotBaseUrl) return undefined

  const flatBaseUrl = slotBaseUrl.replace(new RegExp(`/${svcProfile}$`), '')
  if (!flatBaseUrl || flatBaseUrl === slotBaseUrl) return undefined

  const slotPrefix = `${flatBaseUrl}/${svcProfile}`

  const rewriteUrl = (url) => {
    if (typeof url !== 'string' || !url.startsWith(flatBaseUrl)) {
      return url
    }

    const rest = url.slice(flatBaseUrl.length)
    if (rest === `/${svcProfile}` || rest.startsWith(`/${svcProfile}/`)) {
      return url
    }

    return `${slotPrefix}${rest}`
  }

  const nativeFetch = window.fetch.bind(window)

  window.fetch = function nfPolnApiFetchShim(input, init) {
    if (typeof input === 'string') {
      return nativeFetch(rewriteUrl(input), init)
    }

    if (input instanceof Request) {
      const rewritten = rewriteUrl(input.url)
      if (rewritten === input.url) {
        return nativeFetch(input, init)
      }
      return nativeFetch(new Request(rewritten, input), init)
    }

    return nativeFetch(input, init)
  }

  window[SHIM_FLAG] = true

  if (import.meta.env?.VITE_DEBUG_CONFIG === '1') {
    console.log('[nf:widget-shim] poln_api fetch rewrite', { flatBaseUrl, slotBaseUrl })
  }

  return () => {
    window.fetch = nativeFetch
    delete window[SHIM_FLAG]
  }
}
